import type { MetricKey, TrendDirection } from '@vitalai/health-models';

export const METRIC_LABELS: Record<MetricKey, string> = {
  hrv: 'HRV',
  restingHeartRate: 'FC en reposo',
  sleepDuration: 'Duracion de sueno',
  deepSleep: 'Sueno profundo',
  remSleep: 'Sueno REM',
  sleepEfficiency: 'Eficiencia de sueno',
  spo2: 'SpO2',
  respiratoryRate: 'Frec. respiratoria',
  steps: 'Pasos',
  activeCalories: 'Calorias activas',
  exerciseMinutes: 'Minutos de ejercicio',
  nutritionCalories: 'Calorias',
  proteinIntake: 'Proteina',
  weight: 'Peso',
};

export const METRIC_UNITS: Record<MetricKey, string> = {
  hrv: 'ms',
  restingHeartRate: 'lpm',
  sleepDuration: 'min',
  deepSleep: 'min',
  remSleep: 'min',
  sleepEfficiency: '%',
  spo2: '%',
  respiratoryRate: 'rpm',
  steps: '',
  activeCalories: 'kcal',
  exerciseMinutes: 'min',
  nutritionCalories: 'kcal',
  proteinIntake: 'g',
  weight: 'kg',
};

export function trendArrow(trend: TrendDirection): string {
  if (trend === 'up') return '▲';
  if (trend === 'down') return '▼';
  return '▬';
}

export function formatMinutesAsHours(totalMinutes: number): string {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = Math.round(totalMinutes % 60);
  return `${hours} h ${minutes.toString().padStart(2, '0')} min`;
}

export function formatTime(iso: string): string {
  const date = new Date(iso);
  return date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'UTC' });
}

export function formatDateShort(dateKey: string): string {
  const date = new Date(`${dateKey}T00:00:00.000Z`);
  return date.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', timeZone: 'UTC' });
}

export function formatWeekday(dateKey: string): string {
  const date = new Date(`${dateKey}T00:00:00.000Z`);
  return date.toLocaleDateString('es-ES', { weekday: 'short', timeZone: 'UTC' });
}
